import React from "react";
import { Pencil, Paperclip } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { briefRows } from "@/lib/pkgBrief";

export const BriefSummary = ({ p, onEdit, testId = "brief-summary" }) => (
  <dl className="divide-y divide-slate-100 text-sm" data-testid={testId}>
    {briefRows(p).map(([k, v], i) => (
      <div key={k} className="py-2.5 grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_auto] gap-3 items-start" data-testid={`${testId}-row-${i}`}>
        <dt className="text-slate-500">{k}</dt>
        <dd className="font-medium text-aic-navy break-words">
          {k.startsWith("Piantina") && p.brief?.attachment ? <a href={mediaUrl(p.brief.attachment)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline"><Paperclip className="w-3.5 h-3.5"/>Apri allegato</a> : v}
        </dd>
        {onEdit ? <button type="button" onClick={() => onEdit(i)} data-testid={`${testId}-edit-${i}`} className="text-xs text-gold font-semibold inline-flex items-center gap-1 hover:underline"><Pencil className="w-3 h-3"/>Modifica</button> : <span/>}
      </div>
    ))}
  </dl>
);
